var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512.002 512.002",
    style: {
      enableBackground: "new 0 0 512.002 512.002"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 0.001,
    style: {
      fill: "#F5F5F5"
    },
    width: 239.32,
    height: 512
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#873250"
    },
    d: "M512.001,0H130.99c0.356,0,0.71,0.053,1.05,0.158l81.484,24.898c3.394,1.036,3.391,5.842-0.003,6.877  l-70.722,21.533c-3.395,1.035-3.397,5.839-0.003,6.877l70.729,21.615c3.394,1.036,3.391,5.842-0.003,6.875l-70.723,21.535  c-3.395,1.035-3.397,5.839-0.003,6.877l70.729,21.615c3.394,1.036,3.391,5.842-0.003,6.875l-70.701,21.525  c-3.397,1.036-3.397,5.844,0,6.878l70.701,21.526c3.395,1.035,3.397,5.839,0.003,6.877l-70.729,21.615  c-3.394,1.038-3.391,5.844,0.003,6.877l70.723,21.533c3.395,1.033,3.397,5.839,0.003,6.877l-70.729,21.615  c-3.394,1.038-3.391,5.842,0.003,6.877l70.723,21.533c3.395,1.033,3.397,5.839,0.003,6.875l-70.729,21.615  c-3.394,1.038-3.391,5.844,0.003,6.877l70.722,21.535c3.395,1.033,3.397,5.839,0.003,6.875l-70.729,21.613  c-3.394,1.038-3.391,5.842,0.003,6.877l70.702,21.53c3.396,1.033,3.396,5.842,0,6.875l-70.702,21.53  c-3.395,1.033-3.397,5.839-0.003,6.875l70.729,21.615c3.394,1.036,3.391,5.842-0.003,6.875l-81.484,24.811  c-0.339,0.104-0.692,0.156-1.047,0.156h381.011L512.001,0L512.001,0z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQa);
export default __webpack_public_path__ + "static/media/qa.1005791131b299a1a52b5f1c998182ce.svg";
export { ForwardRef as ReactComponent };